import theme from './theme';

export const size = (multiplier = 1) => {
  const baseUnit = Number.parseFloat(theme.distances.baseUnit);
  return `${(multiplier * baseUnit) / 16}rem`;
};
